(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["reviews-slider-section"] && !Shopify.designMode) return;
  try {
    
(function waitForJQuery() {
  if (typeof jQuery === 'undefined') {
    setTimeout(waitForJQuery, 100);
    return;
  }

  jQuery(function ($) {
    var MAX_DOTS = 7;
    var TX_NEXT = -18;
    var TX_PREV = 18;

    function setBoundries($slider) {
      $slider.find('ul.slick-dots li').eq(6).addClass('n-small-1');
    }

    function debounce(func, wait) {
      var timeout;
      return function () {
        clearTimeout(timeout);
        timeout = setTimeout(func, wait);
      };
    }

    function initSlider() {
      var $slider = $('.reviews-slider');
      var transformCount = 0;

      $slider.on('init', function () {
        var $this = $(this);
        if ($this.find('.slick-dots-container').length === 0) {
          $this.find('ul.slick-dots').wrap("<div class='slick-dots-container'></div>");
        }
        $this.find('ul.slick-dots li').each(function (index) {
          $(this).addClass('dot-index-' + index);
        });
        $this.find('ul.slick-dots').css('transform', 'translateX(0)');
        setBoundries($this);
      });

      $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var $this = $(this);
        var $dots = $this.find('ul.slick-dots');
        var totalCount = $this.find('.slick-dots li').length;

        if (totalCount <= MAX_DOTS) return;

        if (nextSlide > currentSlide) {
          var $nextDot = $this.find('ul.slick-dots li.dot-index-' + nextSlide);
          if (!$nextDot.hasClass('n-small-1')) return;
          if ($this.find('ul.slick-dots li:last-child').hasClass('n-small-1')) return;

          transformCount += TX_NEXT;
          $nextDot.removeClass('n-small-1');
          $this.find('ul.slick-dots li.dot-index-' + (nextSlide + 1)).addClass('n-small-1');
          $dots.css('transform', 'translateX(' + transformCount + 'px)');

          var pPointer = nextSlide - 3;
          $this.find('ul.slick-dots li').eq(pPointer - 1).removeClass('p-small-1');
          $this.find('ul.slick-dots li').eq(pPointer).addClass('p-small-1');
        } else {
          var $prevDot = $this.find('ul.slick-dots li.dot-index-' + nextSlide);
          if (!$prevDot.hasClass('p-small-1')) return;
          if ($this.find('ul.slick-dots li:first-child').hasClass('p-small-1')) return;

          transformCount += TX_PREV;
          $prevDot.removeClass('p-small-1');
          $this.find('ul.slick-dots li.dot-index-' + (nextSlide - 1)).addClass('p-small-1');
          $dots.css('transform', 'translateX(' + transformCount + 'px)');

          var nPointer = currentSlide + 3;
          $this.find('ul.slick-dots li').eq(nPointer).removeClass('n-small-1');
          $this.find('ul.slick-dots li').eq(nPointer - 1).addClass('n-small-1');
        }
      });

      $slider.slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: false,
        arrows: true,
        dots: true,
        prevArrow:
          '<button class="slick-prev" aria-label="Previous" type="button">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">' +
          '<rect width="24" height="24" fill="transparent"/>' +
          '<path d="M14.5 17L9.5 12L14.5 7" stroke="#000" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg></button>',
        nextArrow:
          '<button class="slick-next" aria-label="Next" type="button">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">' +
          '<rect width="24" height="24" fill="transparent"/>' +
          '<path d="M9.5 7L14.5 12L9.5 17" stroke="#000" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg></button>',
        responsive: [
          { breakpoint: 1500, settings: { slidesToShow: 4, slidesToScroll: 1 } },
          { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 1 } },
          { breakpoint: 768,  settings: { slidesToShow: 1, slidesToScroll: 1, arrows: true, dots: true } }
        ]
      });
    }

    function resetSlider() {
      var $slider = $('.reviews-slider');
      if (!$slider.hasClass('slick-initialized')) return;

      var originalHtml = $('.reviews-slider-clone').html();
      $slider.slick('unslick');
      $('.reviews-slider-section .slick-dots-container').remove();
      $slider.html(originalHtml);
      initSlider();
    }

    initSlider();
    $(window).on('resize', debounce(resetSlider, 200));
  });
})();

  } catch(e) { console.error(e); }
})();
})();
